module.exports = __webpack_public_path__ + "img/jumpseller_2.b3fe9376.png";